module.exports = {
    // basic
    'uploader': 'cargador',
    'standard': 'estándar',
    'group-by-entry-type': 'agrupar por tipo de entrada',
    'modify-files': 'modificar archivos',
    'show-entry-history': 'demostrar historia de entrada',
    'send': 'enviar',
    'resend-email': 'reenviar email',
    'resend-text': 'reenviar texto',
    'an-existing-contact': 'un contacto existente para completar sus detalles',
    'contact-info': 'informacion de contacto',
    'last-edited': 'ultimo cambio',
    'confirm': 'confirme',
    'entry-history': 'historia de entrada',
    'email-text-subject': 'correo electrónico / tema de texto',
    'doc-approval-entries': 'documentos esperando aprobación',
    'more': 'más',
    'dept-or-role': 'departamento o oficio',
    'partners': 'socios',
    'auditWell': 'Audit Well',
    'administrators': 'administradores',
    'manage-contacts': 'Gestionar Contactos',
    'prod-data': 'datos de producción',
    'non-prod-data': 'datos de no producción',
    'update-profile': 'Actualización del perfil',
    // raw
    'resend-email-help': `Elija los destinatarios de la lista a continuación.`,
    'resend-text-help': `Elija destinatarios de la lista a continuación, o agregue uno ingresando su número de celular.`,
    'confirm-entry-delete': 'Las entradas que siguen estarán eliminadas:',
    'confirm-entry-not-delete': 'Las entradas que siguen no estarán eliminadas debido a insuficiente derechos:',
    'enter-remarks': 'Debes escribir comentarios.',
    'entry-remarks-template': 'Todos los campos de comentarios deben completarse antes de guardar esta entrada.',
    'entry-remarks': 'Los comentarios deben completarse antes de guardar esta entrada.',
    'entry-file-required': 'Esta entrada no tendrá archivos una vez que se realicen las operaciones seleccionadas. Este tipo de entrada requiere que la entrada tenga por lo menos un archivo. Cancele un archivo, elimine, o agregue un nuevo archivo para cargar.',
    'entry-add-upload-date-help': `Para cargar usando la fecha y hora actuales, deje el campo <b>Fecha</b> en blanco. <br /> Úselo solo si necesita retroceder la entrada.`,
    'entry-da-reject-lock': 'Al hacer clic Ok, se detendrá el proceso de aprobación y bloqueara la entrada, obligando que se vuelva a cargar.',
    'entry-da-reject-no-lock': 'Al hacer clic Ok, se rechazara la entrada (se mantendrá en la pagina de "documentos esperando aprobación", etc.), pero todavía se mantendrá abierto para hacer cambios.',
    'entry-deleted': 'Esta entrada ha sido eliminada.',
    'no-entry-history': 'No hay historia de entrada.',
    'download-combined-pdf': 'Descargar PDF Combinado',
    'entry-add-contact': 'Completando este formulario creará un nuevo contacto.',
    'entry-incomplete': `
        Esta entrada esta incompleta porque uno o mas archivos no terminaron de cargarse.<br />
        Estos archivos se muestran en rojo en la lista de archivos, debajo, en el lado derecho.<br />
        Puede completar la entrada haciendo lo siguiente:
        <p>
            <ol>
                <li>Vuelva a adjuntar los archivos mostrados en rojo.</li>
                <li>Elimine los archivos incompletos ya cargados parcialmente.</li>
                <ol>
                    <li>Haga clic en Modificar Archivos en la parte superior de lista de archivos.
                    <li>En la ventana emergente, haga clic en el botón "Eliminar", junto a los archivos en rojo.</li>
                    <ul>
                        <li>Es posible que deba cerrar este mensaje antes de poder ver la ventana emergente.</li>
                    </ul>
                    <li>Haga clic <b>Ok</b> en la ventana emergente.
                </ol>
                <li>Haga clic en la caja <b>Preservar fecha de carga<b> para preservar la posición de la entrada en la pagina de entradas.</li>
                <li>Haga clic en <b>Guardar.</b></li>
                <li>Espere a que la barra de estado de carga llegue al 100% y que se actualice la pagina de Entradas antes de cerrar su pestaña o navegador. <br />
            </ol>
        </p>
        Esto reemplazara los archivos incompletos marcados en rojo y completara la entrada. </li>
    `,
    'remarks-too-large': 'Observaciones datos demasiado grandes.',
    'entry-contact-required': `Se requiere un contacto para cargar. Seleccione un contacto de la lista. Si no existen contactos, haga clic en <b>Agregar contacto</b> para agregar uno nuevo.`,
    'update-profile-help': `Actualice su perfil con un <b>Número de celular</b> y un <b>Operador de celular.</b> Esto ayuda a garantizar que WellDrive pueda comunicarse con usted si hay algún problema con los datos.`,
    'cell-number-required': `Por favor ingrese el número de celular`,
    'cell-carrier-required': `Por favor, seleccione un operador de telefonía celular`,

    // template
    'resend-text-limit-help': (words) => `
        Los comentarios de esta entrada exceden el límite de <span class="text-danger">${words[0]}</span> caracteres y se truncarán. Si desea evitar esto, edite la entrada para que tenga menos caracteres en los comentarios.
    `,
    'entry-filename-length': (words) => `El nombre de archivo ${words[0]} contiene ${words[1]} caracteres, que excede el limite de ${words[2]} caracteres.'`,
    'entry-filename-length-warning': (words) => `El nombre de archivo "${words[0]}" contiene ${words[1]} caracteres, lo que puede causar problemas con algunas aplicaciones.`,
    'entry-filename-bad-chars': (words) => `El nombre de archivo ${words[0]} contiene tipo de letra de imprenta ilegales.`,
    'entry-filename-whitespace': (words) => `El nombre de archivo ${words[0]} tiene espacios adicionales al principio y/ o al final.`,
    'entry-filename-exists': (words) => `Un archivo con el nombre ${words[0]} ya existe.`,
    'entry-filename-exists-in-uploader': (words) => `Un archivo con el nombre ${words[0]} ya esta en la cola de carga.`,
    'entry-filename-invalid': (words) => `El nombre de archivo ${words[0]} es invalido.`,
    'entry-edit-contact': (words) => `Cualquier cambio a este formulario editara el contacto "${words[0]}".`,
    'entry-rejection-info': (words) => `Rechazado por ${words[0]} en ${words[1]}: <br />${words[2]}`,
    'sms-limit': (words) => `Este tipo de entrada permite que los comentarios se puedan enviar como un mensaje de texto.  Puedes escribir cuanto quieras, pero dependiendo en el ISP del recipiente, el mensaje que ellos reciben puede ser truncado después de <b><span id="smsCharacterLimit">${words[0]}</span></b>  personajes.  Numero de personaje corriente:`,
    'step-approval-info': (words) => `${words[0]} abrobado por ${words[1]} en ${words[2]}<br />`,
    'delete-fail': (words) => `${words[0]} eliminar falló.`,
    'invalid-filename': (words) => `El archivo "${words[0]}" no tiene extensión (es decir .pdf, .txt, .xslx, .las, .docx), o la extensión no es válida.`,
    'confirm-entry-delete-detail': (words) => `\n${words[0]}: ${words[1]}, ${words[2]}: ${words[3]}, ${words[4]}: ${words[5]}`,
    'delete-done': (words) => `${words[0]} eliminado`,

};
